var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31015 12.4109L11.8564 14.6576C12.3097 14.9448 12.8725 14.5177 12.738 13.9886L11.7134 9.95808C11.6845 9.84582 11.688 9.7277 11.7233 9.6173C11.7586 9.5069 11.8243 9.4087 11.9129 9.334L15.093 6.68719C15.5108 6.33941 15.2951 5.64595 14.7583 5.61111L10.6054 5.34158C10.4935 5.33359 10.3862 5.29399 10.296 5.22738C10.2058 5.16078 10.1363 5.06991 10.0957 4.96537L8.54688 1.06492C8.50478 0.953958 8.42992 0.858427 8.33224 0.791015C8.23456 0.723603 8.11868 0.6875 8 0.6875C7.88132 0.6875 7.76544 0.723603 7.66777 0.791015C7.57009 0.858427 7.49523 0.953958 7.45312 1.06492L5.90426 4.96537C5.86367 5.06991 5.79423 5.16078 5.70401 5.22738C5.61378 5.29399 5.5065 5.33359 5.39464 5.34158L1.24171 5.61111C0.704864 5.64595 0.489198 6.33941 0.907042 6.68719L4.08709 9.334C4.17571 9.4087 4.24145 9.5069 4.27674 9.6173C4.31204 9.7277 4.31546 9.84582 4.2866 9.95808L3.33641 13.6959C3.175 14.3309 3.85036 14.8434 4.39432 14.4988L7.68985 12.4109C7.78254 12.3519 7.89013 12.3205 8 12.3205C8.10987 12.3205 8.21747 12.3519 8.31015 12.4109V12.4109Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.046aefd642d54b8b69037428080f148b.svg";
export { ForwardRef as ReactComponent };